import { validators } from '@innovamat/radiance-utils';

import type { UserInvitation } from '../../../../hooks/use-complete-invitation/invitation';

type UserInvitationForm = UserInvitation & {
  acceptTerms: boolean;
  phoneDialCode: string;
};

const isValidUserInvitationForm = ({
  firstName,
  lastName,
  password,
  phoneNumber,
  phoneDialCode,
  acceptTerms,
}: UserInvitationForm): boolean => {
  return (
    !!firstName.trim() &&
    !!lastName.trim() &&
    validators.passwordIsValid(password) &&
    validators.isPhoneValid(phoneNumber, phoneDialCode) &&
    acceptTerms
  );
};

export { isValidUserInvitationForm };
